<template>
  <div class="page-combo-list">
    <skeleton v-if="created && loading" />
    <ym-loadmore v-else
                 v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"
    >
      <combo-list :list="list"
                  :show-empty="allLoad"
      />
    </ym-loadmore>
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import Skeleton from '@/skeleton/ProductList';
  import ComboList from '@/pages/Combo/components/ComboList';
  import { getComboList } from '@/services/combo';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageComboList',
    metaInfo() {
      return {
        title: this.render.pageTitle,
      };
    },
    components: {
      'ym-loadmore': Loadmore,
      Skeleton,
      ComboList,
    },
    data() {
      return {
        created: false,
        list: [],
        start: 0,
        allLoad: false,
        loading: false,
        render: {
          pageTitle: '系列列表',
        },
        query: null,
      };
    },
    methods: {
      async fetchData(created = false) {
        if (this.allLoad) return;
        this.loading = true;
        this.created = created;

        const { start, query } = this;
        const params = Object.assign(
          {
            limit: LIMIT,
            start,
          },
          query,
        );
        const data = await getComboList(params, true);

        this.created = false;
        this.render = { pageTitle: '系列列表' };

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }

        this.list = [...this.list, ...data.list];
        this.start = data.start;
        this.loading = false;
      },
    },
    created() {
      const { query } = this.$route;
      this.query = query;
      this.fetchData(true);
    },
    beforeRouteUpdate(to, from, next) {
      const { query } = to;
      this.query = query;
      this.fetchData(true);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-combo-list {
    min-height: 100%;
    background-color: @color-white;
  }
</style>
